var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.jurisdictions.length > 0
    ? _c("div", { staticClass: "viq-upsell-jur" }, [
        _c("div", { staticClass: "viq-upsell-jur__header" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 14 14",
                fill: "none",
              },
            },
            [
              _c("circle", {
                attrs: {
                  cx: "7",
                  cy: "7",
                  r: "6",
                  stroke: "currentColor",
                  "stroke-width": "1.2",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M7 4v3M7 9h.01",
                  stroke: "currentColor",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", [_vm._v("Additional coverage available")]),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "viq-upsell-jur__text" }, [
          _vm._v("\n    Relevant content was found in\n    "),
          _c("strong", [_vm._v(_vm._s(_vm.jurisdictions.join(", ")))]),
          _vm._v("\n    — not included in your current subscription.\n  "),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "viq-upsell-jur__actions" }, [
          !_vm.interested
            ? _c(
                "button",
                {
                  staticClass: "viq-upsell-jur__btn",
                  on: { click: _vm.expressInterest },
                },
                [_vm._v("I'm interested in upgrading")]
              )
            : _c("span", { staticClass: "viq-upsell-jur__confirmed" }, [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "12",
                      height: "12",
                      viewBox: "0 0 12 12",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M2.5 6l2.5 2.5 4.5-5",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                      },
                    }),
                  ]
                ),
                _vm._v("\n      Thanks — we'll be in touch\n    "),
              ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }